import { render, staticRenderFns } from "./PermisosModulos.vue?vue&type=template&id=5530a50c&"
import script from "./PermisosModulos.vue?vue&type=script&lang=js&"
export * from "./PermisosModulos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports